import React from "react";
const LummellaForm = () => {
  return <h1>LummellaForm</h1>;
};

export default LummellaForm;
